 import { Header } from "@/components/Header";
 import { Footer } from "@/components/Footer";
 import { SEO } from "@/components/SEO";
 import { Button } from "@/components/ui/button";
 import { Card, CardContent } from "@/components/ui/card";
 import { Users, Globe, Shuffle, Shield, ArrowRight, Coffee, Zap, Heart } from "lucide-react";
 import { Link } from "react-router-dom";
 
 const features = [
   { icon: Globe, title: "글로벌 매칭", description: "전 세계 다양한 사람들과 무작위로 매칭되어 함께 공부하세요." },
   { icon: Shuffle, title: "새로운 만남", description: "매 세션마다 새로운 사람을 만나 신선한 동기부여를 받으세요." },
   { icon: Shield, title: "안전한 환경", description: "모든 사용자는 검증되며, 건전한 학습 환경이 유지됩니다." },
   { icon: Coffee, title: "휴식 모드", description: "집중 모드와 휴식 모드를 번갈아 사용하며 효율적으로 공부하세요." },
   { icon: Zap, title: "바디 더블링", description: "누군가와 함께 있다는 느낌이 집중력을 크게 향상시킵니다." },
   { icon: Heart, title: "커뮤니티", description: "같은 목표를 가진 사람들과 연결되어 서로 응원하세요." },
 ];
 
 export default function StudyWithStrangersKr() {
   return (
     <div className="min-h-screen bg-background">
       <SEO 
         title="새로운 사람과 공부하기 | CSW | Online Workspace | Productivity Tool | Study Stream"
         description="전 세계 낯선 사람들과 함께 공부하세요. 글로벌 매칭, 바디 더블링, 안전한 학습 환경을 제공합니다."
         keywords="새로운 사람과 공부하기, 바디 더블링, 온라인 스터디, 글로벌 스터디, 스터디 매칭"
         canonicalUrl="/kr/study-with-strangers/"
       />
       <Header />
       
       <main>
         <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
           <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-muted" />
           <div className="absolute top-20 left-20 w-96 h-96 bg-primary/20 rounded-full blur-[120px] animate-glow-pulse" />
           
           <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
             <div className="max-w-4xl mx-auto text-center space-y-8">
               <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight">
                 <span className="text-gradient">새로운 사람과 공부하기</span>
               </h1>
               <p className="text-xl sm:text-2xl text-muted-foreground font-light max-w-xl mx-auto">
                 전 세계 낯선 사람들과 함께하며 새로운 동기부여를 얻으세요.
               </p>
               <Button size="lg" className="group bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-8 py-6 text-lg" asChild>
                 <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                   지금 시작하기 <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                 </a>
               </Button>
             </div>
           </div>
         </section>
 
         <section className="py-24 px-4 relative overflow-hidden">
           <div className="container mx-auto max-w-6xl">
             <div className="text-center mb-16">
               <h2 className="text-4xl md:text-5xl font-bold font-display mb-6">
                 왜 <span className="text-gradient">낯선 사람</span>과 공부할까요?
               </h2>
             </div>
             <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
               {features.map((feature) => {
                 const Icon = feature.icon;
                 return (
                   <Card key={feature.title} className="group bg-card/50 backdrop-blur-sm border-border/50 hover:border-primary/50 transition-all hover:scale-105">
                     <CardContent className="p-8 space-y-4">
                       <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center">
                         <Icon className="w-6 h-6 text-primary" />
                       </div>
                       <h3 className="text-xl font-semibold text-foreground font-display">{feature.title}</h3>
                       <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
                     </CardContent>
                   </Card>
                 );
               })}
             </div>
           </div>
         </section>
 
         <section className="py-24 px-4 relative overflow-hidden">
           <div className="max-w-4xl mx-auto text-center">
             <h2 className="text-4xl md:text-5xl font-bold mb-6 font-display">
               <span className="text-gradient">새로운 친구</span>를 만나세요
             </h2>
             <Button size="lg" className="group bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-10 py-7 text-lg" asChild>
               <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                 무료로 시작하기 <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
               </a>
             </Button>
           </div>
         </section>
       </main>
       
       <Footer />
     </div>
   );
 }